import type { SmartViewWidget } from "../../../../../../api/types/dashboardsTypes";
import type { TileReportConfigurationForRunning } from "../../../../../../api/types/svTypes.ts";
import SmartViewTileContainer from "./SmartViewTileContainer";

interface Props {
  widget: SmartViewWidget;
  data: TileReportConfigurationForRunning;
}
const SmartViewTileWidget = ({ widget, data }: Props) => {
  return <SmartViewTileContainer data={data} widget={widget} />;
};

export default SmartViewTileWidget;
